import { ModalService } from './../../../providers/modal-service/ModalService';
import { ConfigService } from './../../../providers/config/config.service';
import { MyAccountService } from '../../../providers/my-account/my-account.service';
import { UserManagerService } from '../../../providers/services/userManager/user-manager.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MyAccountComponent } from '../my-account.component';
import { SkeletonServiceService as SkeletonService } from 'src/app/components/skeleton-service.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { NgModel } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
  providers: [DatePipe, NgModel]
})
export class AccountsComponent implements OnInit {
  withdrawalAmt = 0;
  noHandler: any;
  yesHander: any;
  conFirmMsg: string;
  depositAmt = 0;
  depositCode = '';
  inPutPin = '';
  phoneNumber: string = '';
  phoneFeatures: {length: number; startDigits: string; error: number} = {length: 8, startDigits: "", error: 0};
  otp = '';
  msg: string = '';
  status: string = '';
  suffixPhone: string = "";
  msgWithdrawal = ""
  msgDeposit = ""
  retrait: boolean;
  invalidNumber: boolean = false;
  invalidMessage: string = '';
  transactions: Array<any> = [];
  isProcessingWithdrawal = false;
  isProcessingDeposit = false;
  requireConfirmation = false;
  headers: Array<any> = [
    {
      name: 'deposit',
      id: 1
    },
    {
      name: 'withdrawal',
      id: 2
    },
    {
      name: 'history',
      id: 3
    }
  ];
  providers: any[] = [];
  paymentMethods: Array<any> = [];
  activeHeader: any;
  filteredAccnts: Array<any> = [];
  activeMethod: any = {};
  accountParams: any = {};
  fromDate: any = new DatePipe(moment.locale('en')).transform(new Date(), 'yyyy-MM-dd');
  toDate: any = new DatePipe(moment.locale('en')).transform(new Date(), 'yyyy-MM-dd');
  isLoading: boolean = false;
  processingOTP: boolean = false;
  pin = '';
  timeOut: any;
  constructor(
    public accountService: MyAccountService,
    public configService: ConfigService,
    public translate: TranslateService,
    public modalService: ModalService,
    public skeleton: SkeletonService,
    public usermanagerService: UserManagerService) {
    this.accountParams = {
      uid: this.usermanagerService.userData.customer_ID,
      lgn: this.usermanagerService.userData.login,
      pin: this.usermanagerService.userData.str_PIN ? this.usermanagerService.userData.str_PIN : '',
      chl: '3',
      wtp: 'B',
      ref: '' + new Date().getTime(),
      // id: this.usermanagerService.userData.external_payment_tef,
      acc: this.usermanagerService.userData.account_code,
      // lang: this.usermanagerService.userData.lang ? this.usermanagerService.userData.lang : navigator.language.split('-')[0],
      lang: this.usermanagerService.userData.lang ? this.usermanagerService.userData.lang : this.translate.currentLang,
      opr: ''
    };

    this.usermanagerService.onLogIn.subscribe(data => {
      // console.log(this.modalService);
      this.modalService.destroy();
    })

  }
    sendOTP() {
      this.msgWithdrawal = undefined;
      this.msgWithdrawal = undefined;
      if (this.activeMethod.is_mobile && (isNaN(Number(this.phoneNumber)) || !this.phoneNumber)) {
        this.msg = "invalid_phone_number";
        return;
      }
      if (isNaN(Number(this.withdrawalAmt)) || !this.withdrawalAmt) {
        this.msg = this.translate.instant("amt_must_be_greater_than",{amt: (this.activeMethod.min ? this.activeMethod.min : 0)} )
        return;
      }
      if(!this.configService.useGateway){
        this.PMUGWithdrawal();
        return;
      }
      if (Number(this.withdrawalAmt) < Number(this.activeMethod.min)) {
        this.msg = this.translate.instant("minimum_authorised_amt", {amt: this.activeMethod.min})
        return;
      }
      if (Number(this.withdrawalAmt) > Number(this.activeMethod.max)) {
        this.msg = this.translate.instant("max_authorised_amt" ,{amt: this.activeMethod.max})
        return;
      }
      if(this.configService.checkBalance){
        if(Number(this.withdrawalAmt)  > Number(this.usermanagerService.userData.balances.winnings)){
          this.msg = this.translate.instant('insuf_funds' , {amt: this.usermanagerService.userData.balances.winnings});
          return;
        }
      }

      this.isProcessingWithdrawal = true;
      this.accountService.getOTP(this.withdrawalAmt.toString(), true).then(data => {
    if (data.erc == '1') {
      this.requireConfirmation = true;

        this.retrait = this.activeMethod.code == 'VISA UBA'? true : false;


      }
      else {
        this.msgWithdrawal = data.msg ? data.msg : this.translate.instant('erreur lors de la transaction');
      }
      // console.log("data",data)
    }).catch(err => {
      console.error(err);
    }).finally(() => {
      this.isProcessingWithdrawal = false;
    });

  }

  switcHeader(header) {
    if (header.id === 2 && !this.usermanagerService.userData.profile_completed && this.configService.useGateway) {
      const msg = 'complete_signup_to_withdraw';
      this.modalService.openDialog('security_alert', msg, true, "").then(async data => {
        if (data.yesClicked) {
          this.accountService.activeAccountstab = 3;
          this.modalService.init(MyAccountComponent, { activeTab: 1 , mobileTab:3}, {});
        } else {
        }
      });
      return;
    }
  this.activeHeader = header;
  if (header.id === 1) {

    this.accountService.getProviders(this.activeHeader.id).then(data => {
      // console.log(this.accountService.paymentProviders);
      this.providers = this.accountService.paymentProviders[this.activeHeader.id];
      this.selectMethod(this.accountService.paymentProviders[this.activeHeader.id][0]);
    }).catch(err=>{
      console.log(err)
    });;
  } else if (header.id === 2) {
    this.accountService.getProviders(this.activeHeader.id).then(data => {
      this.providers = this.accountService.paymentProviders[this.activeHeader.id].filter((provider) => provider.is_voucher || this.usermanagerService.userData.providers.some((userProvider) => userProvider.pvd === provider.code));;
      this.selectMethod(this.accountService.paymentProviders[this.activeHeader.id][0]);
    }).catch(err=>{
      console.log(err)
    });
  } else if (header.id === 3) {
    // this.fromDate = new Date().setHours(23,59,0,0)
    this.fromDate = this.fromDate.setDate(this.fromDate.getDate() - 7)
    const params = {
      sid: this.usermanagerService.userData.session,
      lg_Customer_Account_ID: this.usermanagerService.userData.customer_ID,
      day: this.fromDate,
      day2: this.toDate,
      tp: this.status,
      // transactiontype: this.status,
    };
    this.getHistory(params);
  }

  }
  getHistory(params?: any) {
    if (!params) {
      params = {
        sid: this.usermanagerService.userData.session,
        lg_Customer_Account_ID: this.usermanagerService.userData.customer_ID,
        day: this.fromDate,
        day2: this.toDate,
        tp: this.status,
        // transactiontype: this.status,
      };
    }
    // if(this.skeleton.theme.name == 'lonani'){
    //   params = {
    //     sid: this.usermanagerService.userData.session,
    //     // lg_Customer_Account_ID: this.usermanagerService.userData.customer_ID,
    //     day: this.fromDate,
    //     day2: this.toDate,
    //     tp: this.status,
    //     pvd: '0'
    //     // transactiontype: this.status,
    //   };
    // }
    this.transactions = [];
    this.isLoading = true;
    this.usermanagerService.getAccountTransactions(params).then(res => {
      if(res.hasOwnProperty("erc") && res.erc == '1'){
        this.transactions = res.data? res.data: [];
        this.isLoading = false;
      }
    }).catch(err => {

    }).finally(() => {
      this.isLoading = false;

    });
  }

  setStartDate(val){
    this.fromDate = val;
  }
  setEndDate(val){
    this.toDate = val;
  }
  ngOnInit() {
    this.switcHeader(this.headers[0]);
    this.accountService.getUserBanks();
    this.usermanagerService.isProcessing = false;
  }

  selectMethod(method: any) {
    this.invalidNumber = true;
    this.activeMethod = method;
    this.phoneNumber = '';
    if(this.activeHeader.id === 2 && method.is_mobile){
      let currentUserMobileProvider = this.usermanagerService.userData.providers.find((userProvider) => userProvider.pvd === method.code);
      if(currentUserMobileProvider){
        this.phoneNumber = currentUserMobileProvider.accnt;
      }
    }
    this.depositAmt = method.min;
    this.withdrawalAmt = method.min;
    this.phoneFeatures.error = 0;
    let mask: string = this.activeMethod.mask;
    if(mask && mask.indexOf('#') > -1 ){
      const [startDigits, phoneLength] = mask.split('#');
      this.phoneFeatures.length = Number(phoneLength);
      this.phoneFeatures.startDigits = startDigits.split('-').join(",");
    }else {
      this.phoneFeatures.length = this.configService.phoneNumberLength;
      this.phoneFeatures.startDigits = '';
    }
    this.msg = '';
    if(this.activeHeader.id === 2 && method.is_mobile){
      this.verifyPhoneNumber();
    }
    
  }
  closeConfirmMessage() {
    this.conFirmMsg = undefined;
    this.yesHander = undefined;
    this.noHandler = undefined;
  }
  showConfirmDialog() {
    this.conFirmMsg = 'confirm_mobile_withdrawal';
    this.yesHander = this.triggerWithdrawal();
    this.noHandler = this.closeConfirmMessage();
  }
  triggerWithdrawal() {
    this.msgWithdrawal = undefined;
    this.processingOTP = true;
    this.conFirmMsg = undefined;
    if (isNaN(Number(this.withdrawalAmt)) || !this.withdrawalAmt) {
      this.msg = this.translate.instant("amt_must_be_greater_than",{amt: (this.activeMethod.min ? this.activeMethod.min : 0)} );
      // console.log(this.activeMethod.min);
      return;
    }
    if(!this.configService.useGateway){
      this.PMUGWithdrawal();
      return;
    }
    if (Number(this.withdrawalAmt) < Number(this.activeMethod.min)) {
      this.msg = this.translate.instant("amt_must_be_greater_than",{amt: (this.activeMethod.min ? this.activeMethod.min : 0)} );
      // console.log(this.activeMethod.min);
      return;
    }
    if (Number(this.withdrawalAmt) > Number(this.activeMethod.max)) {
      this.msg = this.translate.instant("max_authorised_amt" ,{amt: this.activeMethod.max});
      // console.log(this.activeMethod.max);
      return;
    }

      this.accountParams.amt = this.withdrawalAmt.toString();
      this.accountParams.pdi = this.activeMethod.id;
      this.accountParams.pvd = this.activeMethod.pdv;
      this.accountParams.str_Pin = this.otp;
      this.accountParams.pin = this.otp;
      this.accountParams.phn = this.phoneNumber ?  this.phoneNumber + this.suffixPhone : '';
      this.accountParams.opr = this.activeMethod.id + '';
      this.accountParams.sid = this.usermanagerService.userData.session;
      this.accountParams.partnerID = this.skeleton.theme.partnerID;
      this.isProcessingWithdrawal = true;
      this.accountParams.pdvurl = this.activeMethod.code == 'LONACI' ? 'LONACI_WITHDRAWAL' : this.activeMethod.pdv.replace(' ', '') + '_WITHDRAWAL';
      // this.accountParams['pdvurl'] = this.activeMethod['pdv'].replace(' ', '') + '_WITHDRAWAL';
      this.otp = '';



      this.accountService.confirmRetrait(this.accountParams.pdvurl, this.accountParams).then(data => {
        if (!this.activeMethod.is_voucher) {
          if (data.erc == '1' || (data[0] && data[0].erc == '1')) {
            this.modalService.destroy();
            //  this.modalService.msg = this.configService.getErrorMessage('withdrawal_successful');
            this.modalService.msg = this.translate.instant('your_widthrawal_success', {name: this.activeMethod.name});

            this.modalService.title = 'Bravo !!!!!!';

            this.modalService.showModal();
            if (data.balances || (data[0] && data[0].balances)) {
              this.usermanagerService.updateUserAttribute('balances', data.balances ? data.balances : data[0].balances);
            }
             this.requireConfirmation = false;
          } else {
            this.msg = this.configService.getErrorMessage(data.ERROR_MESSAGE ? data.ERROR_MESSAGE : data[0].ERROR_MESSAGE);
          }

        } else {
          if (!data || !data.erc || data.erc == '0') {

            this.msgWithdrawal = this.configService.getErrorMessage(data.ERROR_MESSAGE ? data.ERROR_MESSAGE : data[0].ERROR_MESSAGE);
          } else {
            this.modalService.destroy();
            switch (this.activeMethod.code.replaceAll(' ', '')) {
              case 'SPORTCASHWITHDRAWAL':
              case 'LONACI': case 'SPORTCASH':
                this.modalService.msg = 'ml_code_sent_email';
                break;

              default:
                this.modalService.msg = 'success_withdrawal_code_sent';
                // 'Opération effectuée avec succès, votre code de retrait vous a été envoyé'
                // this.configService.getErrorMessage(data.ERROR_MESSAGE ? data.ERROR_MESSAGE : data[0].ERROR_MESSAGE)
                break;
            }
            this.requireConfirmation = false;

            this.modalService.title = 'success';
            this.timeOut = setTimeout(()=>{
              if (data.balances || (data[0] && data[0].balances)) {
                this.usermanagerService.updateUserAttribute('balances', data.balances ? data.balances : data[0].balances);
              }
              this.modalService.showModal();
            },750);
          }

        }

      }).catch(error => {
        // console.log(error)
        this.msg = 'verify_internet';
      }).finally(() => {
        this.isProcessingWithdrawal = false;
        this.processingOTP = false;
      });
  }
  closeOTPModal(){
    this.requireConfirmation = false;
  }

  triggerDeposit() {
    this.msgDeposit = "";
    if(!this.configService.useGateway){
      this.PMUGDeposit();
      return;
    }
    if (!this.activeMethod.is_voucher) {
      if (isNaN(Number(this.depositAmt)) || !this.depositAmt) {
        this.msg = this.translate.instant("amt_must_be_greater_than",{amt: (this.activeMethod.min ? this.activeMethod.min : 0)} );
        return;
      }

      if (this.activeMethod.min && (Number(this.depositAmt) < Number(this.activeMethod.min))) {
        this.msg = this.translate.instant("minimum_authorised_amt", {amt: this.activeMethod.min});

        return;
      }
      if (this.activeMethod.max && (Number(this.depositAmt) > Number(this.activeMethod.max))) {
        this.msg = this.translate.instant("max_authorised_amt" ,{amt: this.activeMethod.max});
        return;
      }
      if (this.activeMethod.is_mobile && (isNaN(Number(this.phoneNumber)) || this.phoneNumber.trim() == '')) {
        this.msg = 'invalid_phone_number';
        return;
      }
    }

    this.accountParams.amt = this.depositAmt.toString();
    this.accountParams.code = this.depositCode;
    this.accountParams.phn = this.phoneNumber ? this.phoneNumber + this.suffixPhone: '';
    this.accountParams.pdi = this.activeMethod.id;
    this.accountParams.opr = this.activeMethod.id + '';
    this.accountParams.pvd = this.activeMethod.pdv;
    this.isProcessingDeposit = true;
    this.accountParams.partnerID = this.skeleton.theme.partnerID;
    // this.accountParams.pdvurl = this.activeMethod.code == 'LONACI' ? 'LONACI_DEPOSIT' : this.activeMethod.pdv.replaceAll(' ', '');
    this.accountParams.pdvurl = this.activeMethod.code == 'LONACI' ? 'LONACI_DEPOSIT' : this.activeMethod.pdv.replaceAll(' ', '') + '_DEPOSIT';
    console.log(this.accountParams.pdvurl);
    this.accountService.confirmRecharge(this.accountParams.pdvurl, this.accountParams)
    .then(data => {
      if (data && data.length > 0) {
        if (data[0].erc == '1') {
          // this.msg = this.configService.getErrorMessage(data[0].ERROR_MESSAGE);
          // console.log(this.activeMethod.is_one_step)
          if (!this.activeMethod.is_one_step) {
            this.requireConfirmation = true;
            // data[0].ERROR_MESSAGE = "Veuillez confirmer la demande de retrait avec le code SMS envoye au client, Ref :1117184649463307412890206709244396-000015842"
            this.accountParams.transid = data[0].ERROR_MESSAGE.split('-')[1];
          } else {
            // this.msg = this.configService.getErrorMessage(data[0].ERROR_MESSAGE);
            this.modalService.destroy();
            this.modalService.msg = this.activeMethod.is_mobile ? data[0].ERROR_MESSAGE.split('-')[0] : 'deposited_successfully';
            this.modalService.title = this.translate.instant('success');
            this.modalService.showModal();
            this.depositAmt = 0;
            // this.msg = undefined;
            // this.modalService.destroy();
            this.msg = this.activeMethod.is_mobile ? data[0].ERROR_MESSAGE.toString().split('-')[0] : 'deposited_successfully';
            if (data[0].balances) {
              this.usermanagerService.updateUserAttribute('balances', data[0].balances);
            }
            // this.usermanagerService.redirect ? window.location.assign(this.usermanagerService.redirect.replaceAll('%2F', '/')) : '';
          }

        } else {
          this.msgDeposit = data[0].ERROR_MESSAGE && data[0].ERROR_MESSAGE.length > 0 ? data[0].ERROR_MESSAGE : 'transaction_failed';
        }
      }else{
        this.msgDeposit = 'invalid_coupon';
      }
      this.isProcessingDeposit = false;
    }).catch(error => {
      this.msg = 'verify_internet';
    }).finally(() => {
      this.isProcessingDeposit = false;

    });
  }

  PMUGDeposit(){
    this.isProcessingDeposit = true;
    let params:any = {
      str_LOGIN:this.usermanagerService.userData.login,
      SenderPhone: this.configService.country_code +  this.phoneNumber,
      // SenderPhone: '237' +  this.phoneNumber,
      ReceivePhone:this.configService.RECEIVER_PHONENUMBER,
      str_Type:"CREDIT",
      lg_Agent_ID:this.usermanagerService.userData.customer_ID,
      Provider:this.activeMethod.code,
      Amount:this.depositAmt.toString(),
      email:this.usermanagerService.userData.email,
      SenderPin:this.usermanagerService.userData.pin,
      reference:new Date().getTime(),
    };
    if(this.activeMethod.code =="PMUC"){
      params ={
        str_Login: this.usermanagerService.userData.account_code,
        str_Code: this.depositCode,
        str_Pin: this.usermanagerService.userData.pin,
        lg_Channel_ID : '7'
      };
    }
    this.accountService.triggerPMUGTransactions(this.activeMethod.code + "_DEPOSIT", params).then(data => {
      // console.log(data)
      if(data && this.activeMethod.code == "AIRTEL"){
        this.modalService.destroy();
        this.modalService.msg = 'airtel_deposited_successfully';
        this.modalService.title = this.translate.instant('success');
        this.modalService.showModal();
        this.depositAmt = 0;
        this.phoneNumber = "";
      }
      else if(data[0] && data[0].erc == '1'){
        this.modalService.destroy();
        this.modalService.msg = 'deposited_successfully';
        this.modalService.title = this.translate.instant('success');
        this.modalService.showModal();
        this.depositAmt = 0;
        this.phoneNumber = "";
      }

      //   if (data !== null && data.erc != '0') {
      //     console.log("here")
      //     if (data.ERROR_MESSAGE) {
      //       this.modalService.destroy();
      //       this.modalService.msg =  'deposited_successfully';
      //       this.modalService.title = this.translateService.instant('success');
      //       this.modalService.showModal();
      //       this.depositAmt = '';
      //       this.phoneNumber = "";

      // }}
      else {
        this.msgDeposit = this.translate.instant(isNaN(data[0].ERROR_MESSAGE) ? data[0].ERROR_MESSAGE
                          : this.usermanagerService.findErrorMessage(data[0].ERROR_MESSAGE));


      }
    }).catch(er=>{
      console.log(er)
      if(er.status == 200 && this.activeMethod.code == "AIRTEL"){
        this.modalService.destroy();
        this.modalService.msg = 'airtel_deposited_successfully';
        this.modalService.title = this.translate.instant('success');
        this.modalService.showModal();
        this.depositAmt = 0;
        this.phoneNumber = "";
      }
    }).finally(()=>{
      this.isProcessingDeposit = false;

    })
  }
  PMUGWithdrawal(){
   this.isProcessingWithdrawal = true;
    let params:any = {
      str_Login :this.usermanagerService.userData.login,
      // str_Phone: '237' + this.phoneNumber,
      str_Type:"DEBIT",
      str_Provider_Name:this.activeMethod.code,
      int_Amount:this.withdrawalAmt.toString(),
      str_Pin:this.pin,
      lg_Channel_ID: '3',
    }
    if(this.activeMethod.code =="PMUC"){
      params.str_Winning_Type = "winning";
      params.str_Reference = new Date().getTime();
    }if(this.activeMethod.code == "AIRTEL"){
      params.str_Phone= this.configService.country_code + this.phoneNumber;
    }
    this.accountService.triggerPMUGTransactions(this.activeMethod.code + "_WITHDRAWAL", params).then(data => {

      if(data && data[0] && data[0].erc != '0' && this.activeMethod.code == "AIRTEL"){
        // if(data ){
          this.modalService.destroy();
          this.modalService.msg = this.translate.instant("your_widthrawal_success", {name: 'Airtel Money'});
          this.modalService.title = this.translate.instant('success');
          this.modalService.showModal();
          this.depositAmt = 0;
          this.phoneNumber = "";
        }
        else
          if (data !== null && data.erc != '0') {
            if (data.ERROR_MESSAGE) {
              this.modalService.destroy();
              this.modalService.msg =  this.translate.instant('withdrawal_successfully', {code:data.ERROR_MESSAGE});
              this.modalService.title = this.translate.instant('success');
              setTimeout(() => {
                this.modalService.showModal();
                this.depositAmt = 0;
                this.phoneNumber = "";
              }, 500);


        }}
        else {
          this.msgWithdrawal = data.ERROR_MESSAGE ? (this.translate.instant(isNaN(data.ERROR_MESSAGE) ? data.ERROR_MESSAGE
                            : this.usermanagerService.findErrorMessage(data.ERROR_MESSAGE))) : 'defaultFailed';


        // }
        // this.
      }
    }).finally(()=>{
      this.isProcessingWithdrawal = false;
    })
  }


  initMsgs() {
    this.msg = undefined;
  }
  validateTransaction() {
    // tslint:disable-next-line: triple-equals
    if (!this.otp || this.otp.trim() == '') {
      return;
    }
    // console.log(this.accountParams.pdvurl,this.retrait, this.activeMethod.code )

    if ((this.activeMethod.code !== 'VISA UBA') || this.retrait) {
      this.triggerWithdrawal();
      this.retrait=false;
      return;
    }
    this.processingOTP = true;
    this.accountParams.sms = this.otp;
    // this.accountParams.pdvurl = this.activeMethod.pdv.replace(' ', '') + '_DEPOSIT';
    this.accountService.validateOTP(this.accountParams).then(response => {
      this.processingOTP = false;
      this.otp = '';
      const data = response[0];
      // const data: any = {ERROR_MESSAGE:"Operation Successful !",erc:"1"}



      // console.log(data);

      // tslint:disable-next-line: triple-equals
      if (data.erc == '1') {
        this.modalService.destroy();
        // this.modalService.msg = 'deposited_successfully';
        this.modalService.msg = data.ERROR_MESSAGE? this.configService.getErrorMessage(data.ERROR_MESSAGE) : 'deposited_successfully' ;
        this.modalService.title = this.translate.instant('success');
        this.modalService.showModal();
        this.msg = this.configService.getErrorMessage(data.ERROR_MESSAGE);
        
        if (data.balances) {

          this.usermanagerService.updateUserAttribute('balances', data.balances);
        }
      } else {
        this.msg = this.configService.getErrorMessage(data.ERROR_MESSAGE);
      }
    }).finally(() => {
      this.processingOTP = false;
      this.otp = '';
    });
  }

  setPhoneNumber(phoneNumber: string){
    this.phoneNumber = phoneNumber;
    this.verifyPhoneNumber();
  }
  verifyPhoneNumber(){
    var numberPattern = /^[0-9]{1,}$/;
    var lengthPattern = new RegExp("^[0-9]{" + this.phoneFeatures.length + "}$");
    var startPattern = new RegExp("^" + this.phoneFeatures.startDigits.split(',').join('|') + "[0-9]+$");
    // // var pattern2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(\W|_)).{5,}$/
    var hasRightDigits = numberPattern.test(this.phoneNumber);
    var hasRightLength = lengthPattern.test(this.phoneNumber);
    var hasRightStartDigit = startPattern.test(this.phoneNumber);

    if(!hasRightDigits){
      this.phoneFeatures.error = 2; //digits error
      this.invalidNumber = true;
    }else if(hasRightDigits && !hasRightLength){
      this.phoneFeatures.error = 1; //invalid length error
      this.invalidNumber = true;
    }
    else if(!hasRightStartDigit && hasRightDigits && hasRightLength) {
      this.invalidNumber = true;
      this.phoneFeatures.error = 3; //start digit error
    }else {
      this.invalidNumber = false;
      this.phoneFeatures.error = 0; //no error
    }
  }

  updateDate(transDate: any){
    var event = new Date(Number.parseInt(transDate.toString()));
    var options:any = {weekday:'short',year:'numeric',month:'short',day:'numeric'};
    return event.toLocaleDateString(this.translate.defaultLang, options);
  }

  ngOnDestroy(){
    this.timeOut = undefined;
  }
}

